import { PreviewPanel } from './components/PreviewPanel';
import { Box } from '@mui/system';
import { useState } from 'react';
import { Stack } from '@mui/material';
import { SettingPanel } from './components/SettingPanel';
import { useHtmlText } from './hooks/useHtmlText';

function App() {
  const [tableData, setTableData] = useState(
    `Type,Name,Price,Sale Price
    fruits,Apple,$2,$1
    [^],Grape,$8,[<]
    vegetable,Tomato,$4,$3
    [^],cabbage,$2,$1.5
    [^],Carrots,$2,[<]`.replace(/  */g, "")
  )
  const [separator, setSeparator] = useState("comma")
  const [configs, setConfigs] = useState({
    numThead: 1,
    numTfoot: 0,
  })

  const getHtmlText = useHtmlText()
  const htmlText = getHtmlText(tableData, separator, configs.numThead, configs.numTfoot)

  return (
    <div className="App" >
      <Box sx={{ height: "100vh" }}>

        {/* Title */}
        <Box sx={{ width: "100%", height: "60px", lineHeight: "60px", fontSize: "30px", fontFamily: "Orbitron, sans-serif" }}>
          <span style={{ marginLeft: "1em", color: "cornflowerblue", textShadow: "4px -5px lightblue" }}>{"<> "}</span>
          <span style={{ color: "darkslategray" }}>Table Tag Generator</span>
        </Box>

        {/* Main */}
        <Stack sx={{ height: "calc(100vh - 60px)" }} direction="row" justifyContent="center" spacing={1}>
          {/* Preview */}
          <Box sx={{ minWidth: "500px", width: "60%", padding: "80px 30px 0 30px" }}>
            <PreviewPanel htmlText={htmlText} />
          </Box>
          {/* Setting */}
          <Box sx={{ minWidth: "370px", width: "40%" }}>
            <SettingPanel
              tableData={tableData} setTableData={setTableData}
              setSeparator={setSeparator}
              configs={configs} setConfigs={setConfigs}
            />
          </Box>
        </Stack>
      </Box >
    </div >
  );
}

export default App;
